import {
  InputProvider,
  groupInput,
  input,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";

export const AustraliaPostCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
  apiSecret: input<string>({ validator: nonEmptyValidator }),
});

export type AustraliaPostCarrierValue = InputProvider.Value<
  typeof AustraliaPostCarrierInput
>;

export type AustraliaPostCarrierForm = InputProvider.Form<
  typeof AustraliaPostCarrierInput
>;

export const australiaPostCarrierDefault = (): AustraliaPostCarrierValue => ({
  accountNumber: "",
  apiKey: "",
  apiSecret: "",
});

export const CreateAustraliaPostCarrierForm = memo(
  function CreateAustraliaPostCarrierForm({
    carrierInput,
  }: {
    carrierInput: AustraliaPostCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Account Number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="API Key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
        <RedoTextInput
          label="API Secret"
          placeholder=""
          setValue={carrierInput.inputs.apiSecret.setValue}
          value={carrierInput.inputs.apiSecret.value}
        />
      </Flex>
    );
  },
);
